import AxiosConfig from '../config/axios-config'

export default {

  avaliarTopico (ementaId, avaliacao) {
    return AxiosConfig.secureJalekoAPI().put(`/topico/ementa/${ementaId}/avaliacao`, { avaliacao: avaliacao }).then(response => response.data)
  },

  enviarRelatoAvaliacao (ementaId, texto, url) {
    return AxiosConfig.secureJalekoAPI().post(`/relato-critica/ementa/${ementaId}`, { texto: texto, tipo_relato_id: 1, 'url': url }).then(response => response.data)
  }

}
